import { Auth0WrapperConfig, getCookie } from '@auth/bp-pf-auth';
import { environment } from '../../../../environments/environment';

 const tenantCode = getCookie(`${environment.app_id}_tenant_code`) ||  '';
 const storedConfig = JSON.parse(localStorage.getItem(`${tenantCode}_${environment.app_id}_auth0_config`) || '{}');

export const authConfig = {
  Auth0Data: {
    domain: storedConfig.domain || '',
    clientId: storedConfig.clientId || '',
    authorizationParams: {
      redirect_uri: window.location.origin + '/callback',
      audience: storedConfig.audience,
      scope: 'openid profile email offline_access',
    },
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
  },
};

export const auth0WrapperConfig: Auth0WrapperConfig = {
  baseUrl: environment.platformUrl,
  app_id: environment.app_id,
  baseRoute: 'workbench',
  refreshTokenDefaults:{
    pollIntervalMinutes: 15,
    userInactiveHours: 2,
    accessTokenExpiryHours: 8,  //set the access token 8hr expiry
    refreshBeforeExpiryMinutes: 60 //refresh the token 1hr before expiry
  }
};
